/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Dialog } from './Dialog';
import type { HTMLStr } from './HTMLStr';
import type { Label } from './Label';
import type { MemberWithUser } from './MemberWithUser';
import type { RecordExtra } from './RecordExtra';
import type { RecordScope } from './RecordScope';
import type { Team } from './Team';
import type { User } from './User';

/**
 * Audit 로그 응답용 Record 스키마
 * - RecordDetail에서 event, shared_record만 제외하고 나머지 필드는 유지
 * - title은 None 허용
 */
export type AuditRecordDetail = {
  id: number;
  source: AuditRecordDetail.source;
  workspace_id: number;
  user_id: number;
  owner_id?: number | null;
  member_id: number;
  owner_member_id?: number | null;
  user: User;
  owner?: User | null;
  title?: string | HTMLStr | null;
  duration?: number | null;
  created_at: string;
  rec_date: string;
  filesize: number;
  dialogs?: Array<Dialog> | null;
  status: AuditRecordDetail.status;
  extra?: RecordExtra | null;
  scope: RecordScope;
  teams: Array<Team>;
  accessible_teams: Array<Team>;
  accessible_members: Array<MemberWithUser>;
  labels?: Array<Label> | null;
};

export namespace AuditRecordDetail {
  export enum source {
    ZOOM = 'zoom',
    GOOGLE_MEET = 'google_meet',
    TEAMS_MEET = 'teams_meet',
    PHONE_CALL = 'phone_call',
    VOICE_RECORDER = 'voice_recorder',
    SCREEN_RECORDER = 'screen_recorder',
    MANUAL_UPLOAD = 'manual_upload',
  }

  export enum status {
    CREATED = 'created',
    UPLOADED = 'uploaded',
    TRANSCRIBED = 'transcribed',
    PROCESSED = 'processed',
    FAILED = 'failed',
    NOT_SUPPORTED = 'not_supported',
  }
}
